import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-edit\"><path d=\"M13.4 2.6C13 2.2 12.5 2 12 2s-1 .2-1.4.6L3.4 9.8 2 14l4.2-1.4 7.2-7.2c.8-.8.8-2 0-2.8m-9.8 9.8.6-1.9 1.2 1.2zm2.6-1.2L4.8 9.8l5.1-5.1 1.4 1.4zm6.5-6.5-.6.6-1.4-1.4.6-.6c.2-.2.4-.3.7-.3s.5.1.7.3.3.4.3.7-.1.5-.3.7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol